import React, { useState } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { LoginForm } from './components';
import { ProviderApi } from 'services';
import { useAuthFunctions } from 'contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import maiaLogo from '_assets/common/maia-logo.png';
import MaiaText from 'components/MaiaText';
import RegisterLayout from '../RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/login/side-image.svg';

function LoginPage() {
  const history = useHistory();

  const { loginWithEmailAndPassword, loginWithGoogle, logout } = useAuthFunctions();

  const [errorMessage, setErrorMessage] = useState(null);

  const signInWithEmailAndPasswordHandler = async (email, password, remember) => {
    const { connected, errorCode } = await loginWithEmailAndPassword(email, password, remember);
    if (connected) {
      history.push(routes.home.root);
      return;
    }

    let errorMessage = 'Impossible de se connecter';
    switch (errorCode) {
      case 'auth/invalid-email':
        errorMessage = 'Veuillez saisir une adresse email valide';
        break;
      case 'auth/user-not-found' || 'uth/wrong-password':
        errorMessage = 'Adresse email ou mot de passe incorrect';
        break;
      default:
        break;
    }
    setErrorMessage(errorMessage);
  };

  const signInWithGoogleHandler = async (remember) => {
    const { additionalUserInfo, connected, user } = await loginWithGoogle(remember);

    try {
      if (connected) {
        const { registered } = await ProviderApi.isRegistered(user.email);

        if (!registered) {
          history.push(routes.signup.root, {
            page: 1,
            stepNb: 1,
            email: user.email,
            firstName: additionalUserInfo.firstName,
            lastName: additionalUserInfo.lastName,
            phone: user.phoneNumber,
          });
        } else {
          history.push(routes.home.root);
        }
      }
    } catch (error) {
      await logout();
    }
  };

  const SideComponent = () => (
    <Grid container direction="column" style={{ height: 'auto' }}>
      <Grid container item alignItems="center" justifyContent="center">
        <Box style={{ paddingTop: '10%' }}>
          <img src={sideImage} alt="Computer" width={300} />
        </Box>
      </Grid>

      <Grid container direction="column" style={{ flexGrow: 1 }}>
        <Box style={{ margin: '10% 5%' }}>
          <Typography align="center" variant="h3">
            <MaiaText />,
          </Typography>
          <Typography variant="h3" align="center">
            Le système de gestion en ligne pour les professionnels de loisirs
          </Typography>
        </Box>

        <Box style={{ margin: '10% 5%' }}>
          <Typography variant="h3" align="center">
            Gérez facilement votre activité et mettez la en ligne grâce à <MaiaText />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction="column" style={{ height: 'auto' }}>
        <Grid container item justifyContent="center" alignItems="center" style={{ margin: '48px 0' }}>
          <img alt="Logo Maia" src={maiaLogo} width={400} />
        </Grid>

        <Grid container item>
          <LoginForm
            errorMessage={errorMessage}
            onForgotPasswordClick={() => history.push(routes.passwordReset.root)}
            onGoogleClick={signInWithGoogleHandler}
            onValidate={signInWithEmailAndPasswordHandler}
          />
        </Grid>
      </Grid>
    </RegisterLayout>
  );
}

export default LoginPage;
